export default __webpack_public_path__ + "static/media/com-sky.73a3df43.mp4";